import { FormControl } from '@angular/forms';
import { FuseTranslationLoaderService } from '@fuse/services/translation-loader.service';
import english from './i18n/en.json';
import spanish from './i18n/es.json';
import portuguese from './i18n/pt.json';
var FcSearchInputComponent = /** @class */ (function () {
    function FcSearchInputComponent(fuseTranslationLoaderService) {
        this.showSearchIcon = false;
        this.requiredMark = false;
        this.isLoading = false;
        fuseTranslationLoaderService.loadJsonTranslations({ english: english, portuguese: portuguese, spanish: spanish });
    }
    return FcSearchInputComponent;
}());
export { FcSearchInputComponent };
